// extracted by mini-css-extract-plugin
export default {"title":"style_title__3V4pP","categoryItem":"style_categoryItem__4apHP","imgBlock":"style_imgBlock__JkQU2","activeCategory":"style_activeCategory__ciKtz"};